import { Box, Flex, Show } from "@chakra-ui/react";
import Logo from "../assets/staderLogo.svg";
import Image from "next/image";
import React from "react";
import SubHeaderHedera from "../SubHeaderHedera";

interface FooterLink {
  title: string;
  key: string;
  link: string;
  onClick?: () => void;
}
interface HeaderWrapperProps {
  children?: React.ReactNode;
  subHeaderItems: FooterLink[];
}

export const HeaderWrapper = ({
  children,
  subHeaderItems,
}: HeaderWrapperProps) => {
  return (
    <Flex my="0.8rem" mt="2rem">
      <Show below="md">
        <Image src={Logo} height={33} width={22} alt="logo" />
      </Show>

      <Box w="100%" mr="1rem">
        {children}
      </Box>

      <Show above="md">
        <SubHeaderHedera headerOptins={subHeaderItems} />
      </Show>
    </Flex>
  );
};
